import React from 'react';
import { createUseStyles } from 'react-jss';
import { IFormField } from '../../schema/interface';

const styles = createUseStyles({
    container: ({ align, hasParent }) => ({
        textAlign: align,
        width: '100%',
        padding: hasParent && '1em 1.5em'
    }),
    titleContainer: ({ align }) => ({
        textAlign: align,
        fontSize: '1.3em',
        width: '100%',
        display: 'block',
        margin: '1em 0 0.5em 0'
    }),
    description: {
        margin: '0'
    },
    img: {
        display: 'block',
        maxWidth: '100%',
        marginBottom: '7px'
    }
});
interface ITitle {
    field: IFormField;
}
const Title: React.FC<{ field: IFormField }> = ({ field }: ITitle) => {
    const { label, presentation, description } = field;
    const hasParent = !!field?.parent;
    const classes = styles({ align: presentation?.alignment, hasParent });
    return (
        <div className={`${classes.container} blockWrapper`}>
            <h5 className={classes.titleContainer} dir="auto">
                {label}
            </h5>
            {field?.presentation?.mediaUrl && (
                <img className={classes.img} src={field.presentation.mediaUrl} alt={field?.label} />
            )}
            {description && (
                <p
                    className={classes.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
        </div>
    );
};
export default Title;
